import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/shadcn/select";

import {
  Button
} from "@/components/shadcn/button";

import { Icon } from "@iconify-icon/solid";
import { Show } from "solid-js";

export const ListPagination = (props) => {

  const total = () => {
    const pageCount = Math.ceil(props.pagination.totalRows / props.pagination.perPage);
    return pageCount > 0 ? pageCount : 1;
  }

  const pages = () => {
    return Array.from({ length: total() }, (_, i) => i + 1);
  }

  const onChange = (page) => {
    props.onChange(page);
  }

  const setPageIndex = (index) => {
    onChange(index);
  }

  const previousPage = () => {
    onChange(props.pagination.currentPage - 1);
  }

  const nextPage = () => {
    onChange(props.pagination.currentPage + 1);
  }

  const getCanPreviousPage = () => {
    return props.pagination.currentPage > 1;
  }

  const getCanNextPage = () => {
    return props.pagination.currentPage < total();
  }

  return (
    <div class="flex items-center justify-center whitespace-nowrap text-sm font-medium">
      <div class="flex items-center space-x-2">
        <Button
          aria-label="Go to first page"
          variant="outline"
          class="flex size-8 p-0"
          onClick={() => setPageIndex(0)}
          disabled={!getCanPreviousPage()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="size-4"
            aria-hidden="true"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m11 7l-5 5l5 5m6-10l-5 5l5 5"
            />
          </svg>
        </Button>
        <Button
          aria-label="Go to previous page"
          variant="outline"
          size="icon"
          class="size-8"
          onClick={() => previousPage()}
          disabled={!getCanPreviousPage()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="size-4"
            aria-hidden="true"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m15 6l-6 6l6 6"
            />
          </svg>
        </Button>
        <div class="flex items-center whitespace-nowrap text-sm font-medium">
          Page
          <Show when={total() > 1} fallback={<span class="mx-1">1</span>}>
            <Select
              class="mx-2"
              value={10}
              onChange={onChange}
              options={pages()}
              itemComponent={props => <SelectItem item={props.item}>{props.item.rawValue}</SelectItem>}
            >
              <SelectTrigger class="h-8">
                <SelectValue class="me-1">{state => state.selectedOption()}</SelectValue>
              </SelectTrigger>
              <SelectContent />
            </Select>
          </Show>
          of {total()}
        </div>
        <Button
          aria-label="Go to next page"
          variant="outline"
          size="icon"
          class="size-8"
          onClick={() => nextPage()}
          disabled={!getCanNextPage()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="size-4"
            aria-hidden="true"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m9 6l6 6l-6 6"
            />
          </svg>
        </Button>
        <Button
          aria-label="Go to last page"
          variant="outline"
          size="icon"
          class="flex size-8"
          onClick={() => setPageIndex(getPageCount() - 1)}
          disabled={!getCanNextPage()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="size-4"
            aria-hidden="true"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m7 7l5 5l-5 5m6-10l5 5l-5 5"
            />
          </svg>
        </Button>
      </div>
    </div>
  );
}
